import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentintalawade() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Talawade MIDC',
        heading: 'Urbania on rent in pune: Urbania On Rent in Talawade MIDC',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Talawade MIDC for corporate teams, industrial staff, families, tourists, and event travelers across the area. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for factory visits, corporate travel, airport transfers, group outings, weddings, and outstation journeys from Talawade MIDC. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from Talawade MIDC, Kalewadi, Pimpri Chinchwad, Chakan, Bhosari, and Pune Airport, we ensure a safe and stress‑free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Talawade MIDC.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Talawade MIDC",
      "description": "Urbania on Rent in Talawade MIDC offers well-maintained Urbania vehicles for local travel, corporate commuting, and group transportation. With spacious interiors, professional chauffeurs, and timely service, it ensures a smooth, safe, and hassle-free travel experience for businesses and families alike."
    },
    {
      "name": "Talawade MIDC Urbania Bus Hire",
      "description": "Talawade MIDC Urbania Bus Hire provides large and comfortable buses suitable for group travel, company outings, and social events. Fully maintained and chauffeur-driven, the buses ensure punctual, safe, and comfortable journeys across Talawade MIDC and nearby areas."
    },
    {
      "name": "Urbania Rental Service Talawade MIDC Pune",
      "description": "Urbania Rental Service Talawade MIDC Pune offers dependable rental solutions for both local and outstation travel. With a fleet of clean, well-maintained Urbania vehicles and experienced drivers, passengers enjoy stress-free and comfortable travel for corporate trips, family tours, and events."
    },
    {
      "name": "Urbania AC Bus on Rent Talawade MIDC",
      "description": "Urbania AC Bus on Rent Talawade MIDC provides fully air-conditioned buses for maximum comfort during group trips, corporate travel, and special events. Trained chauffeurs and well-maintained vehicles guarantee a pleasant and relaxing journey every time."
    },
    {
      "name": "Corporate Urbania Hire Talawade MIDC",
      "description": "Corporate Urbania Hire Talawade MIDC offers professional transportation solutions for office employees, IT parks, and corporate clients. With a focus on punctuality, executive comfort, and trained chauffeurs, it is ideal for business meetings, conferences, and employee commutes."
    },
    {
      "name": "Urbania for Employee Transport Talawade MIDC",
      "description": "Urbania for Employee Transport Talawade MIDC ensures safe and reliable daily commute for employees of factories, IT parks, and offices. Spacious, comfortable, and well-maintained vehicles with professional drivers provide an efficient transport solution for corporate teams."
    },
    {
      "name": "Urbania Airport Transfer Talawade MIDC",
      "description": "Urbania Airport Transfer Talawade MIDC provides hassle-free pickup and drop services to Pune Airport. With ample luggage space, air-conditioned comfort, and trained chauffeurs, passengers can travel to and from the airport conveniently and on time."
    },
    {
      "name": "Luxury Urbania Talawade MIDC",
      "description": "Luxury Urbania Talawade MIDC offers premium vehicles with plush interiors and superior ride quality. Perfect for VIP travel, corporate executives, weddings, and special occasions, it provides a refined and stylish transportation experience."
    },
    {
      "name": "Affordable Urbania Hire Talawade MIDC",
      "description": "Affordable Urbania Hire Talawade MIDC provides cost-effective rental options for local and outstation travel without compromising on comfort or service quality. Ideal for families, groups, and corporate clients, it ensures reliable, punctual, and professional travel."
    },
    {
      "name": "Chauffeur Driven Urbania Talawade MIDC",
      "description": "Chauffeur Driven Urbania Talawade MIDC ensures stress-free travel with trained, verified, and experienced drivers. Vehicles are clean, well-maintained, and comfortable, providing passengers with a safe and smooth travel experience every time."
    },
    {
      "name": "Urbania for Wedding Events Talawade MIDC",
      "description": "Urbania for Wedding Events Talawade MIDC provides elegant and organized transportation for weddings, guests, and family members. With spacious, air-conditioned vehicles and professional chauffeurs, it ensures timely and comfortable travel for all wedding-related occasions."
    },
    {
      "name": "Urbania for Office Trips Talawade MIDC",
      "description": "Urbania for Office Trips Talawade MIDC delivers reliable and comfortable transportation for office commutes, corporate meetings, and team outings. Focused on punctuality and passenger comfort, it provides professional solutions for business travel."
    },
    {
      "name": "Best Urbania Rental Talawade MIDC Pune",
      "description": "Best Urbania Rental Talawade MIDC Pune offers top-rated Urbania rental services known for vehicle quality, reliability, and customer satisfaction. Suitable for local, outstation, and corporate travel, it ensures a safe and seamless experience for all passengers."
    },
    {
      "name": "Urbania Group Travel Talawade MIDC",
      "description": "Urbania Group Travel Talawade MIDC specializes in transporting groups efficiently and comfortably. Whether for corporate outings, tours, or social events, it provides spacious, well-maintained vehicles and professional chauffeurs to ensure a smooth group travel experience."
    },
    {
      "name": "Reliable Urbania Hire Talawade MIDC Pune",
      "description": "Reliable Urbania Hire Talawade MIDC Pune focuses on safe, punctual, and hassle-free transportation. With well-maintained vehicles and experienced drivers, it offers dependable solutions for local, outstation, corporate, and event travel."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Talawade MIDC", "Talawade MIDC Urbania Bus Hire"],
    ["Urbania Rental Service Talawade MIDC Pune", "Urbania AC Bus on Rent Talawade MIDC"],
    ["Corporate Urbania Hire Talawade MIDC", "Urbania for Employee Transport Talawade MIDC"],
    ["Urbania Airport Transfer Talawade MIDC", "Luxury Urbania Talawade MIDC"],
    ["Affordable Urbania Hire Talawade MIDC", "Chauffeur Driven Urbania Talawade MIDC"],
    ["Urbania for Wedding Events Talawade MIDC", "Urbania for Office Trips Talawade MIDC"],
    ["Best Urbania Rental Talawade MIDC Pune", "Urbania Group Travel Talawade MIDC"],
    ["Reliable Urbania Hire Talawade MIDC Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Talawade MIDC",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC is ideal for corporate travel, factory visits, airport transfers, local trips, and outstation journeys, providing comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC offers well-maintained Force Urbania vehicles with modern interiors, ample legroom, and air-conditioning for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC comes with skilled and courteous drivers familiar with Talawade MIDC routes, Pune highways, and outstation roads, ensuring safety, punctuality, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Talawade MIDC for competitive rates with no hidden charges, making group, corporate, and personal travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC offers round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Talawade MIDC are regularly cleaned, sanitized, and serviced to ensure safety, hygiene, and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Talawade MIDC guarantees on-time pickups and dependable service for smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Talawade MIDC available for both local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Talawade MIDC can be booked for local city travel, corporate trips, airport transfers, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Talawade MIDC?',
        answer: 'You can book Urbania On Rent in Talawade MIDC via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why should I choose Urbania On Rent in Talawade MIDC?',
        answer: 'Urbania On Rent in Talawade MIDC offers spacious seating, comfortable interiors, professional drivers, and transparent pricing for corporate, group, or personal travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Talawade MIDC are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Talawade MIDC allows flexible pickup and drop locations across Talawade MIDC, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Talawade MIDC available 24x7?',
        answer: 'Yes, Urbania On Rent in Talawade MIDC operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles in Talawade MIDC are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Talawade MIDC accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout the journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate travel and events?',
        answer: 'Yes, Urbania On Rent in Talawade MIDC is ideal for office trips, corporate events, airport transfers, and outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Manoj Shinde',
        feedback: 'Urbania On Rent in Talawade MIDC provided excellent service for our factory visit. Spacious vehicle and professional driver made the trip smooth.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Kulkarni',
        feedback: 'We hired Urbania On Rent in Talawade MIDC for corporate travel. The vehicle was comfortable, clean, and punctual.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Ajay Patil',
        feedback: 'Urbania On Rent in Talawade MIDC was perfect for our outstation journey. Highly recommend for reliable and comfortable service.',
        rating: 5,
    },
];











































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Talawade MIDC",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-talawade-midc.jpg",
  "description": "Urbania On Rent in Talawade MIDC offers AC and non-AC Urbania buses for corporate trips, employee transport, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses provide safe, comfortable, and convenient transportation in Talawade MIDC and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-talawade-midc"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Talawade MIDC | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Talawade MIDC for corporate trips, employee transport, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Talawade MIDC Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Talawade MIDC, Talawade MIDC Urbania Bus Hire, Urbania Rental Service Talawade MIDC Pune, Urbania AC Bus on Rent Talawade MIDC, Corporate Urbania Hire Talawade MIDC, Urbania for Employee Transport Talawade MIDC, Urbania Airport Transfer Talawade MIDC, Luxury Urbania Talawade MIDC, Affordable Urbania Hire Talawade MIDC, Chauffeur Driven Urbania Talawade MIDC, Urbania for Wedding Events Talawade MIDC, Urbania for Office Trips Talawade MIDC, Best Urbania Rental Talawade MIDC Pune, Urbania Group Travel Talawade MIDC, Reliable Urbania Hire Talawade MIDC Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/57.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentintalawade;